import { DataRequirement_RequirementType, DataRequirement_Status, } from '../proto/tumelo/fundmanager/v1/data_requirement';
import * as libFundRequirement from './fundRequirement';
import * as libFundUniverse from './fundUniverse';
import * as libProvider from './provider';
export const requirementTypeToString = (o) => {
    switch (o) {
        case DataRequirement_RequirementType.REQUIREMENT_TYPE_INVALID:
            return 'Invalid';
        case DataRequirement_RequirementType.UNRECOGNIZED:
            return 'Unrecognized';
        case DataRequirement_RequirementType.UNDERLYING_HOLDINGS:
            return 'Underlying holdings';
        case DataRequirement_RequirementType.FUND_MANAGER_VOTES:
            return 'Fund manager votes';
        case DataRequirement_RequirementType.FUND_MANAGER_SIGNIFICANT_VOTES:
            return 'Fund manager significant votes';
        case DataRequirement_RequirementType.PLSA_STATISTICS:
            return 'PLSA statistics';
    }
};
export const statusToString = (o) => {
    switch (o) {
        case DataRequirement_Status.STATUS_INVALID:
            return 'Invalid';
        case DataRequirement_Status.UNRECOGNIZED:
            return 'Unrecognized';
        case DataRequirement_Status.STATUS_UNAVAILABLE:
            return 'Unavailable';
        case DataRequirement_Status.STATUS_REQUESTED:
            return 'Requested';
        case DataRequirement_Status.STATUS_RECEIVED:
            return 'Received';
        case DataRequirement_Status.STATUS_AVAILABLE:
            return 'Available';
        case DataRequirement_Status.STATUS_REFUSED:
            return 'Refused';
        case DataRequirement_Status.STATUS_PENDING_OUTREACH:
            return 'Pending Outreach';
    }
};
export const prefix = 'dataRequirements/';
export const IDToName = ({ providerID, universeID, requirementID, dataRequirementID }) => {
    return libFundRequirement.IDToName({ providerID, universeID, requirementID }) + '/' + prefix + dataRequirementID;
};
export const nameToID = (name) => {
    const parts = name.split('/');
    if (parts.length !== 8 ||
        !name.startsWith(libProvider.prefix) ||
        !name.includes(libFundUniverse.prefix) ||
        !name.includes(libFundRequirement.prefix) ||
        !name.includes(prefix)) {
        throw new Error(`bad data requirement name: ${name}`);
    }
    return {
        providerID: parts[1],
        universeID: parts[3],
        requirementID: parts[5],
        dataRequirementID: parts[7],
    };
};
